/**
 * 平台业务错误码 ⇒ 用户友好提示语
 *
 * 拦截器优先用 ApiEnvelope.code（已由后端从上游 error_code 映射），
 * 字典未命中或命中通用上游码时回退到 ApiEnvelope.message（含上游 error 原文）。
 */
export const ERROR_CODE_DICT: Record<string, string> = {
  // —— 通用业务 ——
  AUTH_REQUIRED: '登录已失效，请重新登录',
  PERMISSION_DENIED: '当前账号无权限执行该操作',
  INVALID_PARAMS: '提交的参数不符合规范，请检查后重试',
  RATE_LIMITED: '操作过于频繁，请稍后再试',

  // —— 母账户 / 资金 ——
  INSUFFICIENT_BALANCE: '账户余额不足，请先充值或减少金额',
  ORDER_DUPLICATED: '检测到重复流水号，已为您拦截',

  // —— 邀请 / 团队 ——
  INVITE_REQUIRED: '注册必须提供有效邀请码',
  INVITE_NOT_FOUND: '邀请码不存在',
  INVITE_EXPIRED: '邀请码已过期',
  INVITE_DISABLED: '邀请码已停用',
  INVITE_EXhaustED: '邀请码已达使用上限',
  NOT_DIRECT_CHILD: '目标不是您的直接下级',
  CHILD_DISABLED_BY_ADMIN: '该下级由管理员禁用，您无法启用',
  USERNAME_TAKEN: '客户编号已被占用',
  STEPUP_REQUIRED: '需要二次安全验证',
  STEPUP_INVALID: '二次验证失败或已过期',

  FEE_RATE_BELOW_PARENT: '费率不得低于上级',
  FEE_RATE_BELOW_PLATFORM: '费率不得低于平台底价',

  // —— 卡片相关 ——
  CARD_NOT_FOUND: '未找到该虚拟卡，可能已被销户',
  CARD_FROZEN: '该卡已被风控冻结，操作已拒绝',
  CARD_NOT_ACTIVE: '卡片尚未激活，无法发起此操作',
  CARD_LIMIT_EXCEEDED: '已超出该卡段单笔最高额度',

  // —— 持卡人 ——
  HOLDER_KYC_REJECTED: '持卡人 KYC 资料未通过上游风控审核',

  // —— 上游通道 ——
  UPSTREAM_RISK_REJECTED: '上游风控拒绝本次开卡 / 充值，请稍后重试或联系客服',
  UPSTREAM_TIMEOUT: '上游通道超时，请稍后查看处理结果',
  UPSTREAM_UNAVAILABLE: '上游通道暂不可用，请稍后重试',
};

/** 通用上游码：优先展示后端透传的上游原文，避免盖住具体原因 */
const GENERIC_UPSTREAM_CODES = new Set([
  'UPSTREAM_RISK_REJECTED',
  'UPSTREAM_TIMEOUT',
  'UPSTREAM_UNAVAILABLE',
]);

export function translateErrorCode(code?: string, fallback?: string): string {
  if (!code) return fallback || '请求失败，请稍后重试';
  const mapped = ERROR_CODE_DICT[code];
  if (mapped) {
    if (fallback && GENERIC_UPSTREAM_CODES.has(code)) {
      return fallback;
    }
    return mapped;
  }
  return fallback || `请求失败 (${code})`;
}
